module.exports = __webpack_public_path__ + "static/media/p_37_4.9ea97685.png";